import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const ScoreboardWidgetAsyncComponent = AsyncComponent(async () => import('./scoreboard-widget' /* webpackChunkName: "scoreboard-widget" */ ));

export const ScoreboardWidgetAsync = (props) => {
  return <ScoreboardWidgetAsyncComponent {...props}/>
}
